import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { LANGS } from './utils/constants';

class LanguageChip extends React.Component {

    render() {

        const { classes, lang, defaultLang, onClick, onDelete, dataTest, inactive } = this.props;
        const active = onClick ? true : false;
        const isLongLang = lang.length > 2;
        const style = isLongLang ? { width: '40px', borderRadius: '16px', backgroundColor: '#01579B' } : { backgroundColor: '#01579B' }

        return (
            <Chip
                data-test={dataTest}
                color="primary"
                avatar={<Avatar data-test={"language-code-" + lang} style={style}>{lang === "und" ? "None" : lang}</Avatar>}
                clickable={active}
                onClick={onClick}
                onDelete={onDelete}
                label={LANGS[lang][defaultLang] ? LANGS[lang][defaultLang] : LANGS[lang]["en"]}
                className={active ?
                    classes.activeChip
                    :
                    inactive ?
                        classes.inactiveChip
                        :
                        classes.chip}
            />
        );
    }
}

LanguageChip.defafultProps = {
    inactive: false
};

LanguageChip.propTypes = {
    inactive: PropTypes.bool,
    dataTest: PropTypes.string,
    classes: PropTypes.object.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    lang: PropTypes.string.isRequired
};

export default withStyles(styles)(LanguageChip);